<template>
  <div>
    <div v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form v-if="operationSelected" class="b-layout">
      <b-card>
        <div v-for="(prop, index) in equipments" :key="prop.caption + index">
          <b-form-checkbox
            class="switch-item"
            v-model="prop.value"
            @change="ChangeOnOff($event, prop)"
            switch >
            {{ prop.equipName }}
          </b-form-checkbox>
        </div>
      </b-card>
      <div class="ml-3">
        <b-card>
          <div class="inp">
            <label>{{ $t('capacidade-de-producao-m-dia') }}</label>
            <label>{{ CapProducao.value | ParseNumber }}</label>
          </div>
        </b-card>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { FiltersMixin } from "../../../mixins/filtersMixin";
import { ParseToNumber } from "../../utils/tools";
import { SingletonInter } from '../_service/singletonInter';

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
     readOnly:{
      type: Boolean,
      default: false,
    }
  },

  mixins: [FiltersMixin],

  data() {
    return {
      attrList: ["CapProducao"],
      CapProducao: 0,
      equipCap: [],
      operations: [{ value: null, text:SingletonInter.$t('selecione-uma-operacao') }],
      operationSelected: null,
      operationAttributeList: [],
      firstLoad: false,
      equipments: [],
      temp: null,
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();

      this.operationAttributeList = SingletonEnginnering.getOperationsProperties(
        this.operationSelected
      ).filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );
        this[attrName].value = ParseToNumber(this[attrName].value);
      });

      this.CapProducao = this.operationAttributeList.find(
        (p) => this.attrList[0] == p.key
      );
      this.updateNode();
    },
    
    "CapProducao.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.firstLoad = true;
        this.operationSelected = this.node.data[0].index;
        this.loadNotInput();
      }

      this.equipments = new Array();
      
      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          let prop = p.clone();
          prop.value = ParseToNumber(prop.value);
          this[p.caption] = prop;
        }
        
        if (p.equipName) {
          let equip = p.clone();
          equip.value = parseInt(equip.value) ? true : false;
          this.equipments.push(equip);
        }
      });
      this.loadEquipments();
    },

    updateNode() {
      let attrs = [];

      if(this.CapProducao.value)
        attrs.push(this.CapProducao.clone())

      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? "1,00" : "0,00";
        attrs.push(prop);
      });
      this.node.attrs = attrs;
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );
      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Status") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }
          if (props[p].caption == "Capacidade") {
            if (props[p].strValue != "") {
              props[p].value = props[p].strValue;
            }
            this.equipCap.push(props[p]);
          }
        });
      });

      this.equipments = auxEquipment;
    },

    ChangeCapacidade() {
      if (this.CapProducao) {
        this.CapProducao.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipCap.find((c) => c.equipName == e.equipName);
          let isTrue = JSON.parse(e.value);
          if (isTrue && cap)
            this.CapProducao.value += parseFloat(
              String(cap.value).replace(",", ".")
            );
        });
      }
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeCapacidade();
      this.updateNode();
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) => o.match(/TD/));
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.ChangeCapacidade();
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
